// The side nav storage contract is shared with `@atlassian/global-top-navigation`,
// which owns the side nav toggle button in the top bar and therefore reads and
// writes the same `localStorage` entry. These are re-exported (rather than
// imported directly at each usage site) to keep every existing import path in
// this package working unchanged.
export {
	NAV_STATE_LS_KEY,
	DEFAULT_COLLAPSED_KEY,
	DEFAULT_WIDTH_KEY,
} from '@atlassian/navigation-common/side-nav-storage';

// Query page size for navigation items
export const DEFAULT_PAGE_SIZE = 100;
